import React, { useEffect, useState } from 'react'
import { styled } from '@mui/system';
import ActivityInput from './ActivityInput';
import { Typography, Dialog } from '@mui/material';
import TableActivityComponent from '../TableComponent/TableActivityComponent';
import { db, auth } from '../../firebase';
import { remove, ref } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import { getCollegeName } from '../HomePage/userManagement';

const MainContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10
});
const UserDet = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    border: '1px solid #D8D0D0',
    borderRadius: '12px',
    width: '70vw'
});
const GenerateButton = styled('button')({
    backgroundColor: '#2560CD',
    padding: '10px 26px',
    color: 'white',
    fontFamily: 'Poppins, sans-serif',
    fontWeight: 500,
    fontSize: '16px',
    borderRadius: '10px',
    cursor: 'pointer',
    '&:hover': {
        background: 'black',
        color: 'white',
        transform: 'scale(1.1)',
    },
});

let activitiesDATA = 0;
let activityLevel, activityEnjoy, activityOutcome;

const AddActivity = ({ data, setData, handlePrevious, handleNextClick, validationError }) => {
    const [showDialog, setShowDialog] = React.useState(false);
    const [userUid, setUserUid] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setUserUid(user.uid);
            } else {
                setUserUid(null);
            }
        });

        return () => {
            unsubscribe();
        };
    }, []);
    const handleAddButtonClick = () => {
        setShowDialog(true);
    };

    const handleActivityDelete = async (index, activityId) => {
        try {
            const activityRef = ref(db, `${getCollegeName()}/Activities/${userUid}/${activityId}`);
            await remove(activityRef);
            const newData = Object.values(data);
            newData.splice(index, 1);
            const updatedData = {};
            newData.forEach((item, idx) => {
                updatedData[`activityId${idx + 1}`] = item;
            });

            setData(updatedData);
        } catch (error) {
            console.error('Error deleting activity:', error);
        }
    };

    const handleActivitySave = (activity) => {
        setData(prevActivities => ({
            ...prevActivities,
            [`activityId${Object.keys(prevActivities).length + 1}`]: activity
        }));
        setShowDialog(false);
    };


    const handleActivityCancel = () => {
        setShowDialog(false);
    };

    const activityArray = Object.values(data);
    activityLevel = activityArray.map(obj => obj.highestLevel);
    activityEnjoy = activityArray.map(obj => obj.enjoyment);
    activityOutcome = activityArray.map(obj => obj.outcome);
    activitiesDATA = activityArray.map(obj => obj.activity);

    return (
        <MainContainer>
            <div style={{ display: 'flex', alignItems: 'flex-start', width: '98%' }}>
                <Typography color='black' style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 600,
                    fontSize: '20px'
                }}>
                    Add extra-curricular, academic and professional activities.
                </Typography>
            </div>
            <UserDet>
                {activityArray.length === 0 && (<div>
                    <Typography
                        style={{
                            fontSize: '14px', fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                        }}>
                        Please include all extracurricular activities in which you have participated, encompassing clubs, sports, artistic pursuits,
                        volunteering, or any other forms of engagement beyond your academic studies.
                    </Typography>
                </div>)
                }
                {activityArray.length > 0 && (
                    <TableActivityComponent data={activityArray} handleActivityDelete={handleActivityDelete} />
                )}
                <GenerateButton onClick={handleAddButtonClick} style={{ marginTop: '10px' }}>
                    Add Activity
                </GenerateButton>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <GenerateButton
                        onClick={handlePrevious}
                    >
                        Previous
                    </GenerateButton>
                    {validationError ? <p style={{ color: 'red', marginTop: '10px', textAlign: 'center' }}>{validationError}</p> : <Typography
                        style={{
                            fontSize: '14px',
                            fontFamily: 'Poppins, sans-serif',
                            fontWeight: 500,
                            textAlign: 'center',
                            width: '100%',
                            marginTop: '16px'
                        }}>
                        <strong>* For optimal outcomes, please add a minimum of three extra-curricular, academic, or professional activities.</strong>
                        <br /><br />
                    </Typography>}
                    <GenerateButton
                        onClick={handleNextClick}
                    >
                        Next
                    </GenerateButton>
                </div>
                <Dialog open={showDialog} onClose={() => setShowDialog(false)} PaperProps={{
                    style: {
                        minWidth: '75%', position: 'absolute', minHeight: "75%",
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '12px'
                    }
                }}>
                    <ActivityInput onSave={handleActivitySave} onCancel={handleActivityCancel} />
                </Dialog>
            </UserDet>
        </MainContainer>
    )
}

export { activitiesDATA, activityLevel, activityEnjoy, activityOutcome };
export default AddActivity;